/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { API } from 'middleware/api';

export const BOOTSTRAP_REQUEST = 'BOOTSTRAP_REQUEST';
export const BOOTSTRAP_FAILURE = 'BOOTSTRAP_FAILURE';
export const BOOTSTRAP_SUCCESS = 'BOOTSTRAP_SUCCESS';

/**
 * Bootstrap the application action.
 *
 * @param {Object} params
 * @param {string} params.locale - The preferred language of the requested response.
 *
 * @return {Object}
 */
export const bootstrap = ({ token, locale } = { locale: 'en' }) => ({
  [API]: {
    endpoint:
      process.env.NODE_ENV === 'production'
        ? `/../v2/bootstrap?language=${locale}`
        : `/../v2/bootstrap?language=${locale}&dev=1`,
    method: 'GET',
    token,
    types: [BOOTSTRAP_REQUEST, BOOTSTRAP_SUCCESS, BOOTSTRAP_FAILURE],
  },
});

export const REFRESH_LOCALE = 'REFRESH_LOCALE';

/**
 * Refresh translated text across reducers.
 *
 * @return {Object}
 */
export const refreshLocale = () => ({
  type: REFRESH_LOCALE,
});

export const SET_READY = 'SET_READY';

/**
 * Action that defines the app as ready.
 *
 * @return {Object}
 */
export const setReady = () => ({
  type: SET_READY,
});
